import { render, staticRenderFns } from "./QuestionPlanDelete.vue?vue&type=template&id=797b8f54&scoped=true&"
import script from "./QuestionPlanDelete.vue?vue&type=script&lang=js&"
export * from "./QuestionPlanDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797b8f54",
  null
  
)

export default component.exports